function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { _translate } from "../../../../../services/core";
import Icon from "../../../../common/icon";
import MenuResponse from "./menu-response";
var _MenuCategory = function MenuCategory(_ref) {
  var _category$child;
  var category = _ref.category,
    _ref$bottom = _ref.bottom,
    bottom = _ref$bottom === void 0 ? false : _ref$bottom,
    onChange = _ref.onChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  if (!category) {
    return null;
  }
  var childMenu = category && Array.isArray(category.child) ? (_category$child = category.child) === null || _category$child === void 0 ? void 0 : _category$child.map(function (categoryChild) {
    return /*#__PURE__*/React.createElement(_MenuCategory, {
      category: categoryChild,
      onChange: onChange
    });
  }) : null;
  var idCollapse = "".concat(category.name, "_").concat(parseInt(Math.random() * 10000));
  return /*#__PURE__*/React.createElement(ListGroupItem, {
    key: idCollapse,
    className: "border-left-0 border-right-0 border-top-0 ".concat(bottom ? 'border-bottom' : 'border-bottom-0', " py-1 text-dark")
  }, /*#__PURE__*/React.createElement("button", {
    "data-bs-toggle": "collapse",
    "data-bs-target": "#".concat(idCollapse),
    "aria-expanded": open,
    "aria-controls": idCollapse,
    role: "button",
    onClick: function onClick() {
      return setOpen(!open);
    },
    className: "w-100 bg-transparent border-0 sj-item-hover ".concat(open ? 'text-wever-blue' : '')
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "col-auto d-flex justify-content-start align-items-center px-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, _translate(category.name))), /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-end align-items-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon-categorized type-1 ml-2",
    name: "caret-".concat(open ? 'down' : 'right')
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: open ? 'inherit' : 'none'
    }
  }, /*#__PURE__*/React.createElement(ListGroup, {
    className: "border-0 py-1"
  }, category.responses && category.responses.map(function (response, indexR) {
    return response && /*#__PURE__*/React.createElement(MenuResponse, {
      key: "".concat(indexR, "_").concat(category.name, "_").concat(response.id, "_").concat(parseInt(Math.random() * 10000)),
      response: response,
      onSelect: onChange
    });
  }), childMenu)));
};
_MenuCategory.propTypes = {
  onChange: PropTypes.func.isRequired,
  category: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  bottom: PropTypes.bool
};
_MenuCategory.defaultProps = {
  bottom: false
};
export default _MenuCategory;